/*
 * Project: BookingEngine
 * Module: PaymentMethods.js
 * @flow
 */

/* eslint-disable max-len */

import React from 'react';
import PropTypes from 'prop-types';

import type { PaymentMethod, PaymentCard } from '../../../FlowTypes';
import RadioSelectIcon from '../../icons/RadioSelectIcon';

const renderCardTypes = (paymentCards, cardSelected, setCardType) => (
  <div className="payment-cards mt-2">
    <ul className="list-unstyled">
      {paymentCards.map((cardType) => <li
        key={cardType.code}
        className={cardSelected === cardType.code ? 'active' : ''}
        onClick={() => setCardType(cardType)}>
        <i className={`fa fa-${cardType.icon_class}`}/>
        <p>{cardType.name}</p>
        <RadioSelectIcon isSelected={cardSelected === cardType.code} />
      </li>)}
    </ul>
  </div>
);

const PaymentMethods = (props: {
  methods: Array<PaymentMethod>,
  method: PaymentMethod,
  onSelect: () => void,
  paymentCards: Array<PaymentCard>,
  cardSelected: String,
  onSelectCard: () => void,
}, context: { t: () => {} }) => (
  <div className="PaymentMethods">
    <h1>{context.t('Select your payment method')}</h1>

    <div className="PMCards">
      {props.methods.map((method) => (
        <div key={method.code} onClick={() => { props.onSelect(method); }}>
          {method.code === props.method.code ? <i className="fa fa-check-circle-o"/> : null}
          <i className="fa fa-credit-card" />
          <b>{method.name}</b>
          {method.request_card_type && renderCardTypes(props.paymentCards, props.cardSelected, props.onSelectCard)}
        </div>
      ))}
    </div>
  </div>
);

PaymentMethods.contextTypes = {
  t: PropTypes.func.isRequired,
};

PaymentMethods.propTypes = {
  methods: PropTypes.array.isRequired,
  method: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PaymentMethods;
